import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as BaseComponents from '@comicrelief/component-library';
import { camelCase } from 'lodash';
import { allowListed } from '@comicrelief/component-library';

const Components = { ...BaseComponents };

const {
  RichText
} = Components;

const ParagraphHTML = ({ data }) => {
  const { snippetCode: { snippetCode } } = data;
  //  Rudimentary checks to ascertain how to process the script
  const isScript = snippetCode.includes('script');
  const scriptHasSrc = snippetCode.includes('src="');

  useEffect(() => {
    if (isScript) {
      // Create a new script we'll append to the DOM
      const script = document.createElement('script');
      script.type = 'application/javascript';
      let scriptApproved = true;

      if (scriptHasSrc) {
        // Grab the source from any 'embed' scripts, and ignore
        // fussy ESLint rule which would just make for messier code
        // eslint-disable-next-line prefer-destructuring
        const thisSrc = snippetCode.split('src="')[1].split('"')[0];
        script.src = thisSrc;
        //  Update our flag as to if the src domain is on the allowlist
        scriptApproved = allowListed(thisSrc);
      } else {
        // Else, it's a self-contained script, so remove the tags to keep the raw code
        script.innerHTML = snippetCode.replace(/(<([^>]+)>)/ig, '');
        // Additional codechecks *could* happen here, updating the 'scriptApproved' flag accordingly
      }

      // Futher process and ultimately append the script to the
      // associated wrapping div, only if the conditions have been met
      if (scriptApproved) {
      // Now we're good to go, handle any data attributes by dividing up script tag:
        let attributeArray = snippetCode.split('<')[1].split('>')[0];
        attributeArray = attributeArray.split(' ');

        attributeArray.forEach((attribute) => {
          // ...purely focussing on what we're interested in:
          if (attribute.startsWith('data')) {
            // Carve up the string accordingly:
            let thisName = attribute.split('data-')[1].split('=')[0];

            // Convert to format required by .dataset function:
            thisName = camelCase(thisName);

            const thisValue = attribute.split('="')[1].split('"')[0];
            // Use the scraped details to add to the script object:
            script.dataset[thisName] = thisValue;
          }
        });
        document.getElementById(data.id).appendChild(script);
      }
    }
  }, []);

  return (
    <div id={data.id}>
      {/* Render any non-scripts embeds */}
      {!isScript
        && <RichText markup={data.snippetCode.snippetCode} />}
    </div>
  );
};

ParagraphHTML.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    snippetCode: PropTypes.shape({
      snippetCode: PropTypes.string
    })
  }).isRequired
};

export default ParagraphHTML;
